import React, { useEffect, useMemo, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { Button } from "../../../components/SystemComponent/Button";
import { Switch } from "../../../components/SystemComponent/Switch";
import { createApi } from "../../../../core/api";

export const DynamicPageEdit = () => {
  const api = useMemo(() => createApi(), []);
  const navigate = useNavigate();
  const { id } = useParams();

  const pageId = Number(id);
  const isCreate = pageId === 0;

  const [code, setCode] = useState("");
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [content, setContent] = useState("");
  const [isPublished, setIsPublished] = useState(false);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (isCreate) return;

    api.dynamicPage.getById(pageId).then((r) => {
      if (r?.ok) {
        const d = r.data?.data ?? r.data;
        setCode(d.code ?? "");
        setTitle(d.title ?? "");
        setDescription(d.description ?? "");
        setContent(d.content ?? "");
        setIsPublished(!!d.isPublished);
      }
    });
  }, [pageId, isCreate, api]);

  const submit = async () => {
    if (!code || saving) return;

    setSaving(true);

    const payload = {
      code,
      title,
      description,
      content,
      isPublished,
    };

    if (isCreate) {
      await api.dynamicPage.create(payload);
    } else {
      await api.dynamicPage.update(pageId, payload);
    }

    navigate("/dashboard/dynamic-page");
  };

  return (
    <div style={{ padding: 24, maxWidth: 1100, margin: "0 auto" }}>
      <div style={{ fontSize: 22, fontWeight: 800, marginBottom: 16 }}>
        {isCreate ? "Create Dynamic Page" : "Edit Dynamic Page"}
      </div>

      <div
        style={{
          display: "grid",
          gridTemplateColumns: "1fr 1fr",
          gap: 12,
          marginBottom: 16,
        }}
      >
        <input
          placeholder="Code *"
          value={code}
          onChange={(e) => setCode(e.target.value)}
          style={input}
        />
        <input
          placeholder="Title"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          style={input}
        />
        <input
          placeholder="Description"
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          style={{ ...input, gridColumn: "1 / -1" }}
        />

        <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
          <span style={{ fontSize: 14, fontWeight: 600 }}>Published</span>
          <Switch value={isPublished} onChange={setIsPublished} />
        </div>
      </div>

      <CKEditor
        editor={ClassicEditor}
        data={content}
        onChange={(_, editor) => {
          setContent(editor.getData());
        }}
      />

      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          gap: 12,
          marginTop: 20,
        }}
      >
        <Button
          variant="ghost"
          onClick={() => navigate("/dashboard/dynamic-page")}
        >
          Cancel
        </Button>
        <Button onClick={submit} loading={saving}>
          Save
        </Button>
      </div>
    </div>
  );
};

const input: React.CSSProperties = {
  height: 42,
  borderRadius: 8,
  border: "1px solid #CBD5E1",
  padding: "0 12px",
  fontSize: 14,
};
